import config from "./config";

export const authStore = {
	get: () => localStorage.getItem(config.AUTH_TOKEN_KEY),
	set: (token) => localStorage.setItem(config.AUTH_TOKEN_KEY, token),
	remove: () => localStorage.removeItem(config.AUTH_TOKEN_KEY),
};
